module.exports = __webpack_public_path__ + "static/media/gray-right-arrow.445eafe0.svg";